import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { makeSelectUnitTypeFieldValue } from 'services/unitTypes/selectors';
import {
    SprayProductPerUnitType,
    SprayProductUnits,
    SprayApplicationRate
} from 'services/sprayEvents/types';
import { selectSprayEventTypeIsWeed } from 'services/sprayEventType/selectors';
import { HALF_THE_CALCULATION } from 'services/sprayEvents/constants';
import {
    selectEffectiveRatio,
    selectTotalArea
} from '../../../../../../selectors';
import { HECTARE } from '../../../ProductRatePerUnitTypeDropdown/constants';
import { OwnProps } from './index';

const selectUnits = (state: AppState, props: OwnProps): SprayProductUnits =>
    (props.product && props.product.units) || 0;

const selectNeedHalfCalculation = (state: AppState, props: OwnProps): boolean =>
    props.needHalfCalculation;

const selectPerUnitType = (
    state: AppState,
    props: OwnProps
): SprayProductPerUnitType => props.product && props.product.perUnitType;

const selectApplicationRate = (
    state: AppState,
    props: OwnProps
): SprayApplicationRate => props.applicationRate;

const selectProductTotal = createDeepEqualSelector(
    selectUnits,
    selectApplicationRate,
    selectPerUnitType,
    selectTotalArea,
    makeSelectUnitTypeFieldValue('name'),
    selectEffectiveRatio,
    selectSprayEventTypeIsWeed,
    selectNeedHalfCalculation,
    (
        units,
        applicationRate,
        perUnitType,
        totalArea,
        unitTypeName,
        effectiveRatio,
        isWeedSpray,
        needHalfCalculation
    ) => {
        const unitType = unitTypeName || '';
        let unitsPerHa;

        if (perUnitType === HECTARE) {
            unitsPerHa = units;
        } else {
            unitsPerHa = (units * applicationRate) / 100;
        }

        const denominator = needHalfCalculation ? HALF_THE_CALCULATION : 1;

        if (isWeedSpray) {
            return `${Number(
                (unitsPerHa * totalArea * effectiveRatio) / denominator
            ).toFixed(2)} ${unitType}`;
        }

        return `${Number((unitsPerHa * totalArea) / denominator).toFixed(
            2
        )} ${unitType}`;
    }
);

const makeSelectProductTotal = (): typeof selectProductTotal =>
    selectProductTotal;

export { makeSelectProductTotal };
